import React from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, Legend);
const VerticalPieChart = ({ grade, correctArr, StuNum }) => {
  const generateLabels = () => {
    const allLabels = [];
    for (let i = 0; i < correctArr.length; i++) {
      allLabels.push(`ข้อที่ ${i + 1}`);
    }
    return allLabels;
  };
  const data = {
    datasets: [
      {
        backgroundColor: [
          "#D18CE0",
          "#290FBA",
          "#1572A1",
          "#9ADCFF",
          "#CCD1E4",
          "#B6FFCE",
          "#F6FFA4",
          "#FDD7AA",
          "#FD5D5D",
          "#FF8080",
        ],
        data: correctArr,
        label: "จำนวนคนที่ตอบถูก",
      },
    ],
    labels: correctArr ? generateLabels() : null,
  };
  const options = {
    animation: false,
    cornerRadius: 20,
    layout: { padding: 0 },
    legend: { display: false },
    maintainAspectRatio: false,
    responsive: true,
    indexAxis: "x",
    scales: {
      xAxes: [
        {
          barThickness: 5,
          maxBarThickness: 5,
          barPercentage: 0.5,
          categoryPercentage: 0.5,
          ticks: {
            // fontColor: theme.palette.text.secondary,
          },
          gridLines: {
            display: false,
            drawBorder: false,
          },
        },
      ],
      yAxes: [
        {
          ticks: {
            stepSize: 1,
          },
          gridLines: {
            borderDash: [2],
            borderDashOffset: [2],
            drawBorder: false,
            zeroLineBorderDash: [2],
            zeroLineBorderDashOffset: [2],
            // color: theme.palette.divider,
            // zeroLineColor: theme.palette.divider,
          },
        },
      ],
    },
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: true,
        text: `จำนวนคนที่ตอบถูกในแต่ละข้อ ของชั้นปีที่ ${grade} (จำนวน ${StuNum} คน)`,
      },
    },
    tooltips: {
      intersect: false,
      borderWidth: 1,
      enabled: true,
      mode: "index",

      //   backgroundColor: theme.palette.background.default,
      //   bodyFontColor: theme.palette.text.secondary,
      //   borderColor: theme.palette.divider,
      //   footerFontColor: theme.palette.text.secondary,
      //   titleFontColor: theme.palette.text.primary,
    },
  };

  return <Bar data={data} options={options} />;
};

export default VerticalPieChart;
